<!-- компонент для рисования группы тарифов в VDS -->
<template>
	<!-- селектор группы тарифов -->
	<div v-if="Groups && Groups.length > 1" class="w5-vds-plan-list-filter-wrapper plan">
		<div class="w5-vds-plan-list-block">
			<div v-for="group in Groups"
				class="w5-vds-plan-list-item groups"
				:key="group.id"
				:class="{ 'selected': group.id == curGroup, 'not-active-item': group.active === false }"
				@click.prevent.stop="onGroupClick(group)">
				<div class="w5-vds-plan-list-item-up">
					<img :src="APIServerUrl + group.image" class="local-group" />
				</div>
				<div class="w5-vds-plan-list-item-down">
					<strong>{{ group.name | ftc }}</strong>
				</div>
			</div>
		</div>
		<div class="description"><p v-withSafeTags="localeFtc(groupDescription)"></p></div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'groupPlanComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['action', 'groups', 'value'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// текущая выбранная группа тарифов
			curGroup: null
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// отфильтрованный список групп тарифов
		Groups() {
			if (!this.groups || !this.groups.length)
				return null

			return this.groups.filter(g => {
				// если точно неактивен
				if (g.active === false)
				{
					// сотрудникам все показываем
					if (this.$store.state.user_type === 'admin')
						return true
					// клиентам такие точно не показываем
					else
						return false
				}

				// любой другой случай (например когда вообще нет флага)
				return true
			})
		},

		// описание группы тарифов
		groupDescription() {
			if (!this.groups || !this.groups.length) return

			let desc = ''
			this.groups.some(group => {
				if (this.curGroup === group.id)
				{
					desc = group.description
					return true
				}
			})

			return desc
		}
	},
	//=========================================================================
	created() {
		// установим значение группы
		this.curGroup = this.formater_StrToInt(this.value)
	},
	//=========================================================================
	methods: {
		onGroupClick(group) {
			// эмуляция фокуса
			this.$emit('focus')
			// запоминаем новое значение
			this.curGroup = group.id
			// сообщаем родителю что у нас поменялось значение по группе
			this.$emit('groupChanged', this.curGroup)
		}
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		// если изменилась группа
		value(value) {
			this.curGroup = this.formater_StrToInt(value)
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// groupPlan.vue?12087c81